import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import defaultImage from "../../../assets/images/default.jpg";
import { permissionError } from "../../../util/Alert";
import Button from "../../extra/Button";
import ImagePreviewModal from "../../extra/ImagePreviewModal";
import Pagination from "../../extra/Pagination";
import Table from "../../extra/Table";
import ToggleSwitch from "../../extra/ToggleSwitch";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import {
  enabledDisabled,
  getWithdraw,
} from "../../store/withdraw/withdraw.action";
import WithdrawDialog from "./WithdrawDialog";

import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import { usePermission } from "../../../hooks/usePermission";
import { baseURL } from "../../../util/config";
import Iconb from "../../extra/Iconb";



const Withdraw = (props) => {

  const { can } = usePermission();

  const canCreate = can("Setting", "Create");
  const canEdit = can("Setting", "Edit");

  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const dispatch = useDispatch();

  const { withdraw } = useSelector((state) => state.withdraw);
  const { dialogue, dialogueType, dialogueData } = useSelector(
    (state) => state.dialogue
  );
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  useEffect(() => {
    dispatch(getWithdraw());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Adjust the delay time as needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(withdraw);
  }, [withdraw]);

  // // pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const handleClick = (withdrawDetail) => {
    if (!hasPermission) return permissionError();
    props.enabledDisabled(
      withdrawDetail,
      withdrawDetail?.isEnabled === true ? false : true
    );
  };

  // Delete Withdraw

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => <span className="text-white fw-normal">{page * rowsPerPage + parseInt(index) + 1}</span>,
    },

    {
      Header: "Image",
      body: "withdraw",
      Cell: ({ row }) => {
        const imageUrl = row.image
          ? row?.image.includes("http")
            ? row?.image
            : baseURL + row?.image
          : defaultImage;

        return (
          <>
            <img
              src={imageUrl}
              width={50}
              height={50}
              alt=""
              srcset=""
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                if (!row.image) return;
                setSelectedImage(imageUrl);
                setShowImageModal(true);
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = defaultImage;
              }}
            />
          </>
        );
      },
    },
    {
      Header: "Name",
      body: "name",
      Cell: ({ row }) => (
        <span className="text-white">{row?.name}</span>
      ),
    },

    {
      Header: "Details",
      body: "details",
      Cell: ({ row }) => {
        const details = Array.isArray(row?.details)
          ? row.details
          : row?.details
            ? [row.details]
            : [];

        if (!details.length) {
          return <span className="text-white">-</span>;
        }

        return (
          <div
            className="d-flex flex-column align-items-start"
            style={{ maxWidth: 280, margin: "0 auto", gap: 4 }}
          >
            {details.map((condition, i) => (
              <div key={i} className="d-flex align-items-start">
                <i
                  style={{
                    color: "#b93160",
                    fontSize: "8px",
                    marginTop: 6,
                    flexShrink: 0,
                  }}
                  className="bi bi-circle-fill text-era"
                ></i>
                <span
                  className="ms-2 text-white"
                  style={{
                    fontWeight: "normal",
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    lineHeight: 1.4,
                    textAlign: "left",
                  }}
                >
                  {condition}
                </span>
              </div>
            ))}
          </div>
        );
      },
    },

    {
      Header: "Created Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white">{dayjs(row.createdAt).format("DD MMM YYYY")}</span>
      ),
    },
    ...(canEdit ? [
      {
        Header: "Edit",
        body: "",
        Cell: ({ row }) => (
          <>
            <Iconb
              newClass={`themeFont boxCenter infobtn userBtn fs-5`}
              btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
              style={{
                borderRadius: "50px",
                margin: "auto",
                height: "45px",
                width: "45px",
                color: "#160d98",
              }}
              isImage={true}
              onClick={() =>
                dispatch({
                  type: OPEN_DIALOGUE,
                  payload: { data: row, type: "withdraw" },
                })
              }
            />
          </>
        ),
      }
    ] : []),

    ...(canEdit ? [
      {
        Header: "is Active",
        body: "",
        Cell: ({ row }) => (
          <>
            <div className="boxCenter">
              <ToggleSwitch
                value={row?.isEnabled}
                onClick={() => handleClick(row)}
              />
            </div>
          </>
        ),
      }] : []),

    // add more columns as needed
  ];
  return (
    <>
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname" >Withdraw Setting </div>
          <div className="sellerMain">
            <div className="tableMain mt-2">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-10">
                    {canCreate && (
                      <Button
                        newClass={`whiteFont`}
                        btnColor={`btnBlackPrime`}
                        btnIcon={`fa-solid fa-plus`}
                        btnName={`Add`}
                        onClick={() => {
                          dispatch({
                            type: OPEN_DIALOGUE,
                            payload: { type: "withdraw" },
                          });
                        }}
                        style={{ borderRadius: "5px", padding: "8px 32px", background: "#b93160" }}
                      />
                    )}

                    {dialogue && dialogueType === "withdraw" && <WithdrawDialog />}
                  </div>
                  <div className="col-2 text-end"></div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                PerPage={rowsPerPage}
                Page={page}
                type={"client"}
                loading={loading}
                shimmer={true}
              />
              <Pagination
                component="div"
                count={withdraw?.length}
                serverPage={page}
                type={"client"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={withdraw?.length}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
      <ImagePreviewModal
        isOpen={showImageModal}
        onClose={() => {
          setShowImageModal(false);
          setSelectedImage("");
        }}
        image={selectedImage}
      />
    </>
  );
};

export default connect(null, { getWithdraw, enabledDisabled })(Withdraw);
